import { createAppAsyncThunk } from '../../../../common/thunk';
import { OnboardingRequest } from '../../onboardingRequest';
import OnboardingServices from '../../../../services/onboarding.services';
import { IAwards, IEducation, ITeamMember } from '../../../../common/interfaces/AdditionalInfoInterfaces';
import {
  AdditionalInfoState,
  AffiliationState,
  AwardState,
  CertificationState,
  TeamMemberState,
  TestimonialState,
} from './additionalInfoSlice';

export interface AdditionalInfoPathRequestData {
  education: IEducation[];
  awards: IAwards[];
  profAssociations: string[];
  testimonials: string[];
  teamMembers: ITeamMember[];
}

export const prepareEducation = (educations: CertificationState[]) => {
  return educations
    .filter(it => !(!it.name && !it.organisation && !it.year))
    .map(it => ({ certificateName: it.name, deliveredBy: it.organisation, yearObtained: +it.year }));
};

export const prepareAwards = (awards: AwardState[]) => {
  return awards.filter(it => !(!it.name && !it.year)).map(it => ({ description: it.name, year: it.year }));
};

export const prepareAffiliations = (affiliations: AffiliationState[]) => {
  return affiliations.filter(it => it.description).map(it => it.description);
};

export const prepareTestimonials = (testimonials: TestimonialState[]) => {
  return testimonials.filter(it => it.description).map(it => it.description);
};

export const prepareTeam = (team: TeamMemberState[]) => {
  return team
    .filter(it => !(!it.picture?.id && !it.name && !it.contact && !it.position))
    .map(it => ({
      picture: it.picture?.id ? { id: it.picture.id || '', url: it.picture.url || '' } : undefined,
      name: it.name,
      contact: it.contact,
      position: it.position,
    }));
};

export const prepareAdditionalInfo = (additionalInfo: AdditionalInfoState) => {
  const { certifications, awards, affiliations, testimonials, team } = additionalInfo;
  return {
    education: prepareEducation(certifications),
    awards: prepareAwards(awards),
    profAssociations: prepareAffiliations(affiliations),
    testimonials: prepareTestimonials(testimonials),
    teamMembers: prepareTeam(team),
  };
};

export const confirmAdditionalInfoStep = createAppAsyncThunk('onboarding/confirmAdditionalInfo', (requestData: OnboardingRequest) => {
  const id = requestData.id;
  if (!requestData.additionalInfo) {
    throw Error('Missed additional Info data');
  }
  return OnboardingServices.confirmOnboardingAdditionalInfo(id, requestData.additionalInfo).then(response => response.data);
});
